import {Component, ElementRef, OnInit} from '@angular/core';
import {WidgetBaseGridComponent} from '../widget-base/widget-base-grid.component';
import {MessageService} from '../../messages/message.service';
import {ConfigurationService} from '../../Configuration/configuration-service';
import {PublisherService} from '../../pusblisher/publisher.service';
import {WidgetService} from '../widget.service';
import {HttpClient} from '@angular/common/http';
import {MessageRowsSelected} from '../../messages/message-rows-selected';
import {DataRow} from '../../DoraData/data-row';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'dora-rows-notes',
  templateUrl: './dora-rows-notes.component.html',
  styleUrls: ['./dora-rows-notes.component.scss']
})
export class DoraRowsNotesComponent extends WidgetBaseGridComponent {

  private notes: string[];

  constructor(elementRef: ElementRef<any>,
              messageService: MessageService,
              configurationService: ConfigurationService,
              publisher: PublisherService,
              widgetService: WidgetService,
              http: HttpClient,
              translate: TranslateService) {
    super(elementRef, messageService, configurationService, publisher, widgetService, http, translate);

    this.flSelectFirstRow = false;
  }

  onParameterInjectedFinished(): void {
    super.onParameterInjectedFinished();

    this.messageService.getMessage(this.EventChannel, MessageRowsSelected, this.CallerName).subscribe(message => {
      const idRows = (message.data as MessageRowsSelected).idRows;

      // set selected rows
      this.dataGrid.selectRows(idRows);

      this.buildNotes();
    });
  }

  private buildNotes(): void {
    this.notes = [];
    this.dataGrid.getSelectedRows().forEach((dataRow) => {
      if (dataRow.Note === undefined || dataRow.Note === '') {
        return;
      }
      if (this.notes.find( note => note === dataRow.Note) === undefined) {
        // note not present: add it into list
        this.notes.push(dataRow.Note);
      }
    });
  }
}
